import React from "react";
import { Route } from "react-router-dom";
import { IonRouterOutlet } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { useUser } from "reactfire";
import { useGame } from "context/gameContext";
import LoadingComponent from "components/loading";
import { LeagueProvider } from "context/leagueContext";
import Lobby from ".";
import UserLobby from "views/userLeague";

const Login = React.lazy(() => import("views/login/"));

const LobbyRoutes = ({ match }) => {
  const { data: user } = useUser();

  const {
    state: { userGameData },
  } = useGame();

  const { t } = useTranslation();
  return (
    <IonRouterOutlet>
      <Route
        exact
        path={match.url}
        render={(props) => {
          return <Lobby {...props} />;
        }}
      />
      <Route
        path={`${match.url}/:tournamentId`}
        render={(props) => {
          return user == null ? (
            <Login />
          ) : !userGameData ? (
            <LoadingComponent green={false} text={t("common.loading")} />
          ) : (
            <LeagueProvider>
              <UserLobby {...props} />
            </LeagueProvider>
          );
        }}
      />
    </IonRouterOutlet>
  );
};

export default LobbyRoutes;
